import { useState } from 'react';
import { Play, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useStartCampaign, useCancelCampaign } from '@/hooks/useCampaigns';
import type { Campaign } from '@/types/api.types';

interface Props {
  campaign: Campaign;
}

export function CampaignActions({ campaign }: Props) {
  const [confirmStart, setConfirmStart] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);

  const { mutate: start, isPending: starting } = useStartCampaign();
  const { mutate: cancel, isPending: cancelling } = useCancelCampaign();

  const canStart = campaign.status === 'draft' || campaign.status === 'scheduled';
  const canCancel = campaign.status === 'running' || campaign.status === 'scheduled';

  if (!canStart && !canCancel) return null;

  return (
    <div className="flex gap-2">
      {canStart && (
        <>
          <Button onClick={() => setConfirmStart(true)} disabled={starting}>
            <Play className="h-4 w-4" />
            Iniciar campanha
          </Button>
          <ConfirmDialog
            open={confirmStart}
            onOpenChange={setConfirmStart}
            title="Iniciar campanha"
            description={`Iniciar "${campaign.name}" agora? Os disparos serão processados imediatamente.`}
            confirmLabel="Iniciar"
            loading={starting}
            onConfirm={() => start(campaign.id, { onSuccess: () => setConfirmStart(false) })}
          />
        </>
      )}

      {canCancel && (
        <>
          <Button variant="outline" className="text-destructive" onClick={() => setConfirmCancel(true)} disabled={cancelling}>
            <X className="h-4 w-4" />
            Cancelar campanha
          </Button>
          <ConfirmDialog
            open={confirmCancel}
            onOpenChange={setConfirmCancel}
            title="Cancelar campanha"
            description={`Cancelar "${campaign.name}"? Os disparos pendentes não serão enviados.`}
            confirmLabel="Cancelar campanha"
            variant="destructive"
            loading={cancelling}
            onConfirm={() => cancel(campaign.id, { onSuccess: () => setConfirmCancel(false) })}
          />
        </>
      )}
    </div>
  );
}
